/* eslint-disable */
export default function init(Blockly, profile) {
    Blockly.Arduino.mqtt = {};

    function mqttserial_varDef(a, b) {
        var c = "SoftwareSerial mqtt_esp8266_serial(" + b + "," + a + ");";
        0 == b && 1 == a && (c = "HardwareSerial &mqtt_esp8266_serial=Serial;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n");
        "Arduino Mega" == profile["default"].description && (19 == b && 18 == a && (c = "HardwareSerial &mqtt_esp8266_serial=Serial1;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"), 17 == b && 16 == a && (c = "HardwareSerial &mqtt_esp8266_serial=Serial2;", Blockly.Arduino.definitions_.define_hardserial =
            "#include <HardwareSerial.h>\n"), 15 == b && 14 == a && (c = "HardwareSerial &mqtt_esp8266_serial=Serial3;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"));
        return c
    }

    function setupMQTT(a, b, c) {
        "" != a && (Blockly.Arduino.definitions_.define_contype = "//IOT: " + a);
        "ethernet" == a && (Blockly.Arduino.definitions_.define_spi = "#include <SPI.h>\n", Blockly.Arduino.definitions_.define_ethernet = "#include <Ethernet.h>\n", Blockly.Arduino.definitions_.define_mqtt = '#include "IOTMQTTEthernet.h"\n', Blockly.Arduino.definitions_.var_mqtt_mac || (Blockly.Arduino.definitions_.var_mqtt_mac = "const byte mqtt_mac[] = {  0xDE, 0xED, 0xBA, 0xFE, 0xFE, 0x01 };"));
        "esp8266" == a && (Blockly.Arduino.definitions_.define_softserial =
            "#include <SoftwareSerial.h>\n", Blockly.Arduino.definitions_.define_mqtt = '#include "IOTMQTTESP8266.h"\n', Blockly.Arduino.definitions_.var_mqtt_esp8266 = mqttserial_varDef(b, c) + "\nESP8266 mqtt_esp8266_wifi(&mqtt_esp8266_serial);");
        Blockly.Arduino.definitions_.var_mqtt_broker || (Blockly.Arduino.definitions_.var_mqtt_broker = 'const char mqtt_broker[]="iot.eclipse.org";');
        Blockly.Arduino.definitions_.var_mqtt_port || (Blockly.Arduino.definitions_.var_mqtt_port = "const int mqtt_port=1883;");
        Blockly.Arduino.definitions_.var_mqtt_user ||
            (Blockly.Arduino.definitions_.var_mqtt_user = 'const char mqtt_user[]="";');
        Blockly.Arduino.definitions_.var_mqtt_pass || (Blockly.Arduino.definitions_.var_mqtt_pass = 'const char mqtt_pass[]="";');
        Blockly.Arduino.definitions_.var_mqtt_clientid || (Blockly.Arduino.definitions_.var_mqtt_clientid = 'const char mqtt_clientid[]="AB_client";');
        Blockly.Arduino.definitions_.var_mqtt_payload = "char mqtt_payload[64];";
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_payload2double = "\ndouble mqtt_payload2double(unsigned char *_payload, int _length){\n\tint i;\n\tfor (i = 0; i<_length && i<64; i++){\n\t\tmqtt_payload[i] = _payload[i];\n\t}\n\tmqtt_payload[i] = 0;\n\treturn atof(mqtt_payload);\n}";
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_payload2string = "\nString mqtt_payload2string(unsigned char *_payload, int _length){\n\tint i;\n\tfor (i = 0; i<_length && i<64; i++){\n\t\tmqtt_payload[i] = _payload[i];\n\t}\n\tmqtt_payload[i] = 0;\n\treturn String(mqtt_payload);\n}";
        Blockly.Arduino.loops_.loop_iot = "\tIOT.loop();";
        Blockly.Arduino.definitions_.var_mqtt_esp8266 && (Blockly.Arduino.loops_.loop_iot = "\tmqtt_esp8266_serial.listen(); IOT.loop();");
        (a = Blockly.Arduino.definitions_.var_mqtt_esp8266) &&
        a.startsWith("HardwareSerial") && (Blockly.Arduino.loops_.loop_iot = "\tIOT.loop();");
        var d;
        a = "void mqtt_callback(char* _topic, unsigned char* _payload, unsigned int _payloadlength){\n\tdouble v=mqtt_payload2double(_payload,_payloadlength);\n\tString vt=mqtt_payload2string(_payload,_payloadlength);\n";
        for (d in Blockly.Arduino.mqtt_sub_) b = Blockly.Arduino.mqtt_sub_[d], a = b.startsWith("s_") ? a + ("\tif(String(_topic)==String(" + d + "))" + b + "=vt;\n") : a + ("\tif(String(_topic)==String(" + d + "))" + b + "=v;\n");
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_callback =
            a + "}\n";
        a = "void mqtt_subscribe(){\n";
        for (d in Blockly.Arduino.mqtt_sub_) a += "\tIOT.Subscribe(String(" + d + "));\n";
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_subscribe = a + "}\n"
    }
    Blockly.Arduino.mqtt_init = function() {
        var a = Blockly.Arduino.quote_(this.getFieldValue("MAC")),
            b = Blockly.Arduino.quote_(this.getFieldValue("BROKER")),
            c = this.getFieldValue("PORT"),
            d = Blockly.Arduino.quote_(this.getFieldValue("USER")),
            e = Blockly.Arduino.quote_(this.getFieldValue("PASS")),
            f = Blockly.Arduino.quote_(this.getFieldValue("CLIENTID"));
        Blockly.Arduino.definitions_.var_mqtt_mac = "byte mqtt_mac[] = {" + a + "};";
        Blockly.Arduino.definitions_.var_mqtt_broker = "const char mqtt_broker[]=" + b + ";";
        Blockly.Arduino.definitions_.var_mqtt_port =
            "const int mqtt_port=" + c + ";";
        Blockly.Arduino.definitions_.var_mqtt_user = "const char mqtt_user[]=" + d + ";";
        Blockly.Arduino.definitions_.var_mqtt_pass = "const char mqtt_pass[]=" + e + ";";
        Blockly.Arduino.definitions_.var_mqtt_clientid = "const char mqtt_clientid[]=" + f + ";";
        setupMQTT("ethernet", 0, 0);
        Blockly.Arduino.setups_.setup_mqtt = "\t IOT.begin(mqtt_broker,mqtt_port, mqtt_user,mqtt_pass, mqtt_clientid, mqtt_mac, mqtt_callback, mqtt_subscribe);";
        return ""
    };
    Blockly.Arduino.mqtt_init_EP = Blockly.Arduino.mqtt_init;
    Blockly.Arduino.mqtt_init_esp8266 = function() {
        var a = Blockly.Arduino.quote_(this.getFieldValue("BROKER")),
            b = this.getFieldValue("PORT"),
            c = Blockly.Arduino.quote_(this.getFieldValue("USER")),
            d = Blockly.Arduino.quote_(this.getFieldValue("PASS")),
            e = Blockly.Arduino.quote_(this.getFieldValue("CLIENTID")),
            f = Blockly.Arduino.quote_(this.getFieldValue("WIFINAME")),
            g = Blockly.Arduino.quote_(this.getFieldValue("WIFIPASS")),
            h = this.getFieldValue("BAUD"),
            k = this.getFieldValue("RX"),
            l = this.getFieldValue("TX");
        Blockly.Arduino.definitions_.var_mqtt_broker =
            "const char mqtt_broker[]=" + a + ";";
        Blockly.Arduino.definitions_.var_mqtt_port = "const int mqtt_port=" + b + ";";
        Blockly.Arduino.definitions_.var_mqtt_user = "const char mqtt_user[]=" + c + ";";
        Blockly.Arduino.definitions_.var_mqtt_pass = "const char mqtt_pass[]=" + d + ";";
        Blockly.Arduino.definitions_.var_mqtt_clientid = "const char mqtt_clientid[]=" + e + ";";
        Blockly.Arduino.definitions_.var_mqtt_wifi_ssid = "const char mqtt_wifi_ssid[]=" + f + ";";
        Blockly.Arduino.definitions_.var_mqtt_wifi_pass = "const char mqtt_wifi_pass[]=" +
            g + ";";
        setupMQTT("esp8266", k, l, h);
        Blockly.Arduino.setups_.setup_mqtt = "\tmqtt_esp8266_serial.begin(" + h + ");\n\tIOT.begin(mqtt_broker,mqtt_port, mqtt_user,mqtt_pass, mqtt_clientid, mqtt_esp8266_wifi, mqtt_wifi_ssid, mqtt_wifi_pass, mqtt_callback, mqtt_subscribe);";
        return ""
    };
    Blockly.Arduino.mqtt_init_esp8266_EP = Blockly.Arduino.mqtt_init_esp8266;
    Blockly.Arduino.mqtt_pub = function() {
        var a = Blockly.Arduino.valueToCode(this, "TOPIC", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''",
            b = Blockly.Arduino.valueToCode(this, "MSG", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''",
            c = "IOT.Publish(String(" + a + "), String(" + b + "));\n";
        Blockly.Arduino.definitions_.var_mqtt_esp8266 && (c = "mqtt_esp8266_serial.listen(); IOT.Publish(String(" + a + "), String(" + b + "));\n");
        var d = Blockly.Arduino.definitions_.var_mqtt_esp8266;
        d && d.startsWith("HardwareSerial") && (c = "IOT.Publish(String(" +
            a + "), String(" + b + "));\n");
        if ("esp8266" == profile["default"].micro || "esp32" == profile["default"].micro) c = "mqtt_client.publish(String(" + a + ").c_str(),String(" + b + ").c_str());\n";
        return c
    };
    Blockly.Arduino.mqtt_sub = function() {
        var a = Blockly.Arduino.valueToCode(this, "TOPIC", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''",
            b = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME);
        Blockly.Arduino.mqtt_sub_[a] = b;
    //    "esp8266" == profile["default"].micro ? setupMQTT_ESP() : "esp32" == profile["default"].micro ? setupMQTT_ESP32() : setupMQTT("", 0, 0);
        setupMQTT_ESP();
        return ""
    };
    Blockly.Arduino.mqtt_sub_text = function() {
        var a = Blockly.Arduino.valueToCode(this, "TOPIC", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''",
            b = Blockly.Arduino.nameDB_Text_.getName(this.getFieldValue("VARTEXT"), Blockly.VARIABLE_CATEGORY_NAME);
        Blockly.Arduino.mqtt_sub_[a] = "s_" + b;
//        "esp8266" == profile["default"].micro ? setupMQTT_ESP() : "esp32" == profile["default"].micro ? setupMQTT_ESP32() : setupMQTT("", 0, 0);
        setupMQTT_ESP();
        return ""
    };
    Blockly.Arduino.mqtt_isconnected = function() {
        var a = Blockly.Arduino.definitions_.var_mqtt_esp8266,
            b = "IOT.isConnected()";
        Blockly.Arduino.definitions_.var_mqtt_esp8266 && (b = "mqtt_esp8266_serial.listen(); IOT.isConnected()");
        a && a.startsWith("HardwareSerial") && (b = "IOT.isConnected()");
        if ("esp8266" == profile["default"].micro || "esp32" == profile["default"].micro) b = "mqtt_client.connected()";
        return [b, Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.mqtt_thingspeak_pub = function() {
        var a = this.getFieldValue("CHANNEL"),
            b = this.getFieldValue("FIELD"),
            c = this.getFieldValue("APIKEY");
        return [Blockly.Arduino.quote_("channels/" + a + "/publish/fields/" + b + "/" + c), Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.mqtt_thingspeak_sub = function() {
        var a = this.getFieldValue("CHANNEL"),
            b = this.getFieldValue("FIELD"),
            c = this.getFieldValue("APIKEY"),
            d = Blockly.Arduino.quote_("channels/" + a + "/subscribe/fields/" + b + "/" + c);
        "" == c && (d = Blockly.Arduino.quote_("channels/" + a + "/subscribe/fields/" + b));
        return [d, Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.mqtt_adafruit_pub = function() {
        var a = this.getFieldValue("USER"),
            b = this.getFieldValue("FEED");
        return [Blockly.Arduino.quote_(a + "/f/" + b), Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.mqtt_adafruit_sub = function() {
        var a = this.getFieldValue("USER"),
            b = this.getFieldValue("FEED");
        return [Blockly.Arduino.quote_(a + "/f/" + b), Blockly.Arduino.ORDER_ATOMIC]
    };

    function setupMQTT_ESP() {
        Blockly.Arduino.definitions_.define_mqtt = '#include "PubSubClient.h"\n';
        Blockly.Arduino.definitions_.var_wificlient = "WiFiClient mqtt_wifiClient;";
        Blockly.Arduino.definitions_.var_mqtt = "PubSubClient mqtt_client(mqtt_wifiClient);";
        Blockly.Arduino.definitions_.var_mqtt_broker || (Blockly.Arduino.definitions_.var_mqtt_broker = 'const char mqtt_broker[]="iot.eclipse.org";');
        Blockly.Arduino.definitions_.var_mqtt_port ||
            (Blockly.Arduino.definitions_.var_mqtt_port = "const int mqtt_port=1883;");
        Blockly.Arduino.definitions_.var_mqtt_user || (Blockly.Arduino.definitions_.var_mqtt_user = 'const char mqtt_user[]="";');
        Blockly.Arduino.definitions_.var_mqtt_pass || (Blockly.Arduino.definitions_.var_mqtt_pass = 'const char mqtt_pass[]="";');
        Blockly.Arduino.definitions_.var_mqtt_clientid || (Blockly.Arduino.definitions_.var_mqtt_clientid = 'const char mqtt_clientid[]="AB_client";');
        Blockly.Arduino.definitions_.var_mqtt_payload = "char mqtt_payload[64];";
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_setupwifi = "\nvoid mqtt_setup(){\n\tdelay(10);;\n\tWiFi.begin(mqtt_wifi_ssid,mqtt_wifi_pass);\n\twhile (WiFi.status() != WL_CONNECTED) delay(500);\n\trandomSeed(micros());\n  mqtt_client.setServer(mqtt_broker, mqtt_port);\n  mqtt_client.setCallback(mqtt_callback);\n\tmqtt_subscribe();\n}";
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_loop = "\nvoid mqtt_loop(){\n\tif (!mqtt_client.connected()) {\n\t\tmqtt_client.connect(mqtt_clientid,mqtt_user,mqtt_pass);\n\t\tmqtt_subscribe();\n\t}\n\tif (mqtt_client.connected()) {\n  \tmqtt_client.loop();\n\t}\n}";
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_payload2double = "\ndouble mqtt_payload2double(unsigned char *_payload, int _length){\n\tint i;\n\tfor (i = 0; i<_length && i<64; i++){\n\t\tmqtt_payload[i] = _payload[i];\n\t}\n\tmqtt_payload[i] = 0;\n\treturn atof(mqtt_payload);\n}";
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_payload2string = "\nString mqtt_payload2string(unsigned char *_payload, int _length){\n\tint i;\n\tfor (i = 0; i<_length && i<64; i++){\n\t\tmqtt_payload[i] = _payload[i];\n\t}\n\tmqtt_payload[i] = 0;\n\treturn String(mqtt_payload);\n}";
        Blockly.Arduino.loops_.loop_mqtt = "\tmqtt_loop();";
        var a;
        var b = "void mqtt_callback(char* _topic, unsigned char* _payload, unsigned int _payloadlength){\n\tdouble v=mqtt_payload2double(_payload,_payloadlength);\n\tString vt=mqtt_payload2string(_payload,_payloadlength);\n";
        for (a in Blockly.Arduino.mqtt_sub_) {
            var c = Blockly.Arduino.mqtt_sub_[a];
            b = c.startsWith("s_") ? b + ("\tif(String(_topic)==String(" + a + "))" + c + "=vt;\n") : b + ("\tif(String(_topic)==String(" + a + "))" + c + "=v;\n")
        }
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_callback =
            b + "}\n";
        b = "void mqtt_subscribe(){\n";
        for (a in Blockly.Arduino.mqtt_sub_) b = "esp8266" == profile["default"].micro ? b + ("\tmqtt_client.subscribe(String(" + a + ").c_str());\n") : b + ("\tmqtt_client.Subscribe(String(" + a + "));\n");
        Blockly.Arduino.definitions_fnc_.fnc_mqtt_subscribe = b + "}\n"
    }
    Blockly.Arduino.mqtt_init_ESP = function() {
        var a = Blockly.Arduino.quote_(this.getFieldValue("BROKER")),
            b = this.getFieldValue("PORT"),
            c = Blockly.Arduino.quote_(this.getFieldValue("USER")),
            d = Blockly.Arduino.quote_(this.getFieldValue("PASS")),
            e = Blockly.Arduino.quote_(this.getFieldValue("CLIENTID")),
            f = Blockly.Arduino.quote_(this.getFieldValue("WIFINAME")),
            g = Blockly.Arduino.quote_(this.getFieldValue("WIFIPASS"));
        Blockly.Arduino.definitions_.var_mqtt_wifi_ssid = "const char mqtt_wifi_ssid[]=" + f + ";";
        Blockly.Arduino.definitions_.var_mqtt_wifi_pass =
            "const char mqtt_wifi_pass[]=" + g + ";";
        Blockly.Arduino.definitions_.var_mqtt_broker = "const char mqtt_broker[]=" + a + ";";
        Blockly.Arduino.definitions_.var_mqtt_port = "const int mqtt_port=" + b + ";";
        Blockly.Arduino.definitions_.var_mqtt_user = "const char mqtt_user[]=" + c + ";";
        Blockly.Arduino.definitions_.var_mqtt_pass = "const char mqtt_pass[]=" + d + ";";
        Blockly.Arduino.definitions_.var_mqtt_clientid = "const char mqtt_clientid[]=" + e + ";";
        setupMQTT_ESP();
        Blockly.Arduino.setups_.setup_mqtt = "\tmqtt_setup();";
        return ""
    };
}